import { useState } from "react";

import { closeIcon } from "../../../assetData/icons";
import BackDrop from "../../ui/BackDrop";
import MirageLoader from "../../ui/pageLoader/MirageLoader";
import { getMappingSchemeId, getMappingTemplateId, getTemplateId, getTemplateName } from "./templatePmsUtils";

const TemplatePMSMappingForm = ({ data, templates, schemes, onClose, onSubmit }) => {
  const isEdit = Boolean(data?.id ?? data?.mapping_id);
  const [form, setForm] = useState({
    pms_scheme: getMappingSchemeId(data) || "",
    pms_template: getMappingTemplateId(data) || "",
    status: data?.status === false || data?.status === 0 || data?.status === "0" ? 0 : 1,
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    const payload = {
      ...(isEdit ? { id: data?.id ?? data?.mapping_id } : {}),
      pms_scheme: Number(form.pms_scheme),
      pms_template: Number(form.pms_template),
      status: form.status ? 1 : 0,
    };
    setSubmitting(true);
    const saved = await onSubmit(payload, isEdit);
    setSubmitting(false);
    if (saved) onClose();
  };

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 w-[95%] max-w-[700px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className="pb-6 text-2xl font-bold text-neutral-800">
          {isEdit ? "Update PMS Template Mapping" : "Create PMS Template Mapping"}
        </h2>
        <button type="button" className="absolute right-8 top-8" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
        <form onSubmit={submit}>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div className="flex flex-col gap-2">
              <label className="text-[#636363]">PMS Scheme*</label>
              <select required value={form.pms_scheme} onChange={(event) => setForm({ ...form, pms_scheme: event.target.value })} className="rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none">
                <option value="">Select</option>
                {schemes.map((scheme) => <option key={scheme.id} value={scheme.id}>{scheme.label}</option>)}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-[#636363]">PMS Template*</label>
              <select required value={form.pms_template} onChange={(event) => setForm({ ...form, pms_template: event.target.value })} className="rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none">
                <option value="">Select</option>
                {templates.map((template) => <option key={getTemplateId(template)} value={getTemplateId(template)}>{getTemplateName(template)}</option>)}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-[#636363]">Status*</label>
              <select value={String(form.status)} onChange={(event) => setForm({ ...form, status: Number(event.target.value) })} className="rounded bg-neutral-100 p-2 text-[#636363] focus:outline-none">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <button disabled={submitting} className="mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-12 py-2 font-semibold text-white sm:w-1/3">
            {submitting ? <MirageLoader /> : isEdit ? "UPDATE" : "ADD"}
          </button>
        </form>
      </div>
      <BackDrop closeHandler={onClose} />
    </>
  );
};

export default TemplatePMSMappingForm;
